
import {AssertUtils,QueryCommand} from "goingutils";


class IconShowObj {
    constructor(vueObj) {
        this.vueObj = vueObj;
    }
}

IconShowObj.prototype.destructor = function () {

};

//获取选择的数据
IconShowObj.prototype.getSelectedRowIds = function (relChar) {
    if(relChar!=null){
        return this.vueObj.recordIds.join(relChar);
    }else{
        return this.vueObj.recordIds;
    }
};
//加载数据
IconShowObj.prototype.reloadData = function () {
    this.flushImgByUrl({url: this.url, params: this.params});
};

//获取图片的url
IconShowObj.prototype.getIconUrl = function (rowId) {
    let backUrl = "";
    for (let num = 0; num < this.vueObj.items.length; num++) {
        let itemObj = this.vueObj.items[num];
        if (itemObj.id === rowId[0]) {
            backUrl = itemObj["url"];
            break;
        }
    }
    return backUrl;
};

//获取图片形态
IconShowObj.prototype.getIconShape = function () {
    return this.vueObj.iconShape;
};

/**
 * 获取子类别名称
 */
IconShowObj.prototype.getSubTypeName = function () {
    return this.vueObj.subTypeName;
};

// 获取图片类别
IconShowObj.prototype.getIconType = function () {
    return this.vueObj.iconType;
};

/**
 * 刷新图片信息
 * @param url
 * @param params
 * @param successFun
 * @param errorFun
 * @param backType
 */
IconShowObj.prototype.flushImgByUrl = function ({
                                                    url,
                                                    params = {},
                                                    successFun
                                                },newPage=false) {
    let imgShowObj = this;
    this.url = url;
    this.params = params;
    //如果newPage为true 则设置当前为第一页
    if(newPage){
        this.vueObj.curPageNum=1;
    }
    successFun = function (backDataJson) {
        let backData=[];
        //获取数据
        if(backDataJson&&backDataJson["list"]!=null){
            backData=backDataJson["list"];
        }
        if(backDataJson&&backDataJson["records"]!=null){
            backData=backDataJson["records"];
        }
        //获取分页总数
        let  totalCount=backData.length;
        if(backDataJson&&backDataJson["total"]){
            totalCount=backDataJson["total"];
        }
        //重置选中的记录数
        imgShowObj.vueObj.recordIds = [];
        if (AssertUtils.isNotNull(backData)) {
            let itemDatas = [];
            //设置记录总数
            imgShowObj.vueObj.totalCount = totalCount;
            //初始化对象的初始值
            backData&&AssertUtils.isArray(backData)&&backData.forEach(function (item) {
                itemDatas.push({
                    ...item,
                    ...{
                        hoverFlag: false,
                        showSubMenu: false,
                        editorName: false,
                        selFlag: false
                    }
                });
            });
            imgShowObj.vueObj.items = [...itemDatas];
        }
    };
    let queryCommand = new QueryCommand({url:url,size:this.vueObj.pageSize,current:this.vueObj.curPageNum});
    params["current"]=this.vueObj.curPageNum;
    queryCommand.executeQuery({params, successFun});
};

export default IconShowObj;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/IconShowObj.js